var exports = {
  "header": "x234b8571--f2e867--header",
  "logo": "x234b8571--f2e867--logo",
  "title": "x234b8571--f2e867--title",
  "red": "x234b8571--f2e867--red",
  "green": "x234b8571--f2e867--green",
  "description": "x234b8571--f2e867--description",
};

module.exports = exports;
